/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { EmailNotificationTypes } from './EmailNotificationTypes';
import { NotificationReasons } from './NotificationReasons';
const PatchNotificationSettingUserSettingDataParser = 
/* #__PURE__ */ parsers.object([
    ['reason', NotificationReasons],
    ['value', EmailNotificationTypes],
]);
export class PatchNotificationSettingUserSettingData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchNotificationSettingUserSettingDataParser.decode(input).map(res => new PatchNotificationSettingUserSettingData(res));
    }
    static unsafeDecode(input) {
        return PatchNotificationSettingUserSettingData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchNotificationSettingUserSettingDataParser.encode(data);
    }
    static schema() {
        return PatchNotificationSettingUserSettingDataParser.schema();
    }
}
